import React from 'react';
import {
    Paper, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Toolbar
} from '@material-ui/core';
import { useUnitSummaryReport } from '~/groupings';
import Dimmer from '+/Dimmer';
import { TableFooter } from 'semantic-ui-react';


const UnitSummaryReport = () => {

    const { data, isLoading } = useUnitSummaryReport();

    if (isLoading) {
        return <Dimmer />;
    }

    if (Object.keys(data).length === 0) {
        return <div> No Groupings Found... </div>;
    }


    return (
        <div>
            {Object.entries(data).map(([property_name, groupings]) => (
                <Paper>
                    <Toolbar>
                        {property_name}
                    </Toolbar>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Unit Group Name</TableCell>
                                    <TableCell>Vacant</TableCell>
                                    <TableCell>Vacant Deposits</TableCell>
                                    <TableCell>ITVs - 30 days</TableCell>
                                    <TableCell>Minimum</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {groupings.map(grouping => (
                                    <TableRow>
                                        <TableCell>{grouping.name}</TableCell>
                                        <TableCell>{grouping.counts.vacant}</TableCell>
                                        <TableCell>{grouping.counts.vacantDeposit}</TableCell>
                                        <TableCell>{grouping.counts.itv}</TableCell>
                                        <TableCell>{grouping.counts.minimum.bldg_unit}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TableCell>Total</TableCell>
                                    <TableCell><strong>{getSum(groupings, 'vacant')}</strong></TableCell>
                                    <TableCell><strong>{getSum(groupings, 'vacantDeposit')}</strong></TableCell>
                                    <TableCell><strong>{getSum(groupings, 'itv')}</strong></TableCell>
                                    <TableCell> </TableCell>

                                </TableRow>
                            </TableFooter>
                        </Table>
                    </TableContainer>
                </Paper>
            ))}

        </div>
    );
};

const getSum = (groupings, type) => groupings.reduce((acc, grouping) => {

    acc += grouping.counts[type];

    return acc;
}, 0);

export default UnitSummaryReport;
